var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHidenPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.72754C10.1946 5.72754 8.72729 7.19479 8.72729 9.00026C8.72729 10.8057 10.1946 12.273 12 12.273C13.8055 12.273 15.2728 10.8057 15.2728 9.00026C15.2728 7.19479 13.8054 5.72754 12 5.72754Z",
    fill: "#4B5168"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.818359C6.54546 0.818359 1.88729 4.21105 0 9.00018C1.88729 13.7893 6.54546 17.182 12 17.182C17.46 17.182 22.1128 13.7893 24.0001 9.00018C22.1128 4.21105 17.46 0.818359 12 0.818359ZM12 14.4547C8.98911 14.4547 6.54546 12.011 6.54546 9.00013C6.54546 5.98922 8.98911 3.54562 12 3.54562C15.0109 3.54562 17.4546 5.98927 17.4546 9.00018C17.4546 12.0111 15.0109 14.4547 12 14.4547Z",
    fill: "#4B5168"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidenPassword);
export default __webpack_public_path__ + "static/media/hidenPassword.13413735bcd8970606e935416987937a.svg";
export { ForwardRef as ReactComponent };